import styled from "styled-components";

export const InboxProfileImage = styled.img`
    border-radius: 50%;
    width: 40px;
    height: 40px;
    object-fit: cover;
`;
